// @flow
import React from 'react';
import styled from 'styled-components';
import { Icon, Badge, ToolTip } from 'primitive-components';
import { colors } from 'bench-style-constants';

const NavIcon = styled(Icon)`
  height: 22px;
  transition: fill 0.25s ease-out;
  width: 22px;
  fill: none;
  stroke: white;
`;

const ArrowIcon = styled(Icon)`
  display: none;

  @media (min-width: 1441px) {
    display: block;
    width: 25px;
    height: 25px;
    fill: none;
    stroke: white;
    position: absolute;
    right: 15px;
    top: 15px;
  }
`;

const UISwitchContainer = styled.div`
  padding: 2px 8px;
  flex: 0 0 100%;
  background-color: ${colors.charcoal};
  @media (min-width: 1441px) {
    padding: 2px 15px;
  }
`;

const StyledButton = styled.button`
  align-items: center;
  border: none;
  color: white;
  cursor: pointer;
  display: flex;
  width: 100%;
  flex-direction: column;
  font-size: 10px;
  padding: 7px 0 5px;
  position: relative;
  transition: color 0.25s ease-out;
  border-radius: 8px;
  background: url(https://assets.bench.co/img/illustrations/UITransitions_nav_s.png) no-repeat;
  background-size: 100% 100%;
  background-color: #1d4586;

  &:focus {
    color: white;
    outline: 0;
  }

  &:hover {
    opacity: 0.8;
  }

  ${Badge} {
    left: 36px;
    position: absolute;
    top: 8px;

    @media (min-width: 1441px) {
      top: 8px;
    }
  }

  @media (min-width: 1441px) {
    padding: 12px 20px;
    align-items: flex-start;
    background: url(https://assets.bench.co/img/illustrations/UITransitions_nav_l.png) no-repeat;
    background-size: 100% 100%;
    background-color: #1d4586;
    color: white;
  }
`;

const ButtonText = styled.div`
  display: none;

  @media (min-height: 700px) {
    display: block;
    font-size: 10px;
    line-height: 15px;
    text-align: center;
  }

  @media (min-width: 1441px) {
    display: none;
  }
`;

const ButtonTextWideSidebar = styled.div`
  display: none;

  @media (min-width: 1441px) {
    display: block;
    font-size: 12px;
    line-height: 16px;
    padding-left: 5px;
    font-weight: bold;
  }
`;

const StyledToolTip = styled(ToolTip)`
  @media (min-height: 700px) {
    display: none;
  }

  @media (min-width: 1441px) {
    display: none;
  }
`;

const ToolTipText = styled.div`
  color: white;
  font-size: 12px;
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (min-width: 1441px) {
    flex-direction: row;
    width: 100%;
  }
`;

const DescriptionText = styled.div`
  display: none;

  @media (min-width: 1441px) {
    display: block;
    text-align: left;
    font-size: 12px;
  }
`;

type SidebarButtonProps = {
  testId?: ?string,
  icon: string,
  onClick: () => void,
  text: string,
  expandedText?: ?string,
  heapId?: ?string,
  appcuesElementId?: ?string,
};

const UISwitchSidebarButton = ({
  testId,
  icon,
  text,
  expandedText,
  onClick,
  heapId,
  appcuesElementId,
}: SidebarButtonProps) => (
  <StyledToolTip
    size="small"
    vPosition="center"
    hPosition="right"
    contentComponent={<ToolTipText>{expandedText || text}</ToolTipText>}
  >
    <UISwitchContainer>
      <div style={{ backgroundColor: 'white', borderRadius: '8px' }}>
        <StyledButton
          id={appcuesElementId}
          data-test-id={testId}
          onClick={onClick}
          data-heap-id={heapId}
        >
          <TitleContainer>
            <NavIcon size="medium" viewBox="0 0 20 20" icon={icon} />
            <ButtonText>{text}</ButtonText>
            <ButtonTextWideSidebar>{expandedText || text}</ButtonTextWideSidebar>
            <ArrowIcon size="large" icon="navigationRightCircle" />
          </TitleContainer>
          <DescriptionText>
            Our platform will soon be updated with a new Bench experience.
          </DescriptionText>
        </StyledButton>
      </div>
    </UISwitchContainer>
  </StyledToolTip>
);

export default UISwitchSidebarButton;

UISwitchSidebarButton.defaultProps = {
  testId: null,
  notificationCount: null,
  expandedText: null,
  heapId: null,
  appcuesElementId: '',
};
